// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activityData .activity-title[data-v-08b0fa25] {\n  height: 70px;\n  line-height: 70px;\n  padding-left: 360px;\n  border-bottom: 2px solid #ccc;\n}\n.activityData .show-data[data-v-08b0fa25] {\n  width: 1200px;\n  margin: 30px auto 0;\n}\n.activityData .show-data[data-v-08b0fa25] .el-tabs__item {\n    padding: 0 40px;\n}\n.activityData .title[data-v-08b0fa25] {\n  font-weight: 400;\n}\n.activityData .title span[data-v-08b0fa25] {\n    font-size: 16px;\n    color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
